import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class ScrollHndler {
    constructor() {
        this.init();
    }

    init() {
        this.changeHeadLogoMode();
        this.setScrollTrigger();
    }

    setScrollTrigger() {
        const revealElm = [...document.querySelectorAll(".js-scrollreveal")];

        for (const el of revealElm) {
            ScrollTrigger.create({
                trigger: el,
                start: "top 85%",
                // markers: true,
                onEnter: () => {
                    el.setAttribute("data-reveal", "1");
                },
            });
        }
    }

    changeHeadLogoMode() {
        const triggerElm = document.querySelector(".js-logo-mode");

        if (!triggerElm) return;

        ScrollTrigger.create({
            trigger: triggerElm,
            start: "top top",
            end: "top bottom",

            onLeave: () => {
                document.body.classList.add("-logoode");
            },
            onEnterBack: () => {
                document.body.classList.remove("-logoode");
            },
        });
    }
}
